import { request } from '../request';

const serviceRecordApi = {
  /**
   * 查询服务记录
   */
  getServiceRecords(date: string) {
    return request<ServiceRecordItem[]>({
      path: '/pad/service/order/v1/list/service/record',
      query: { date },
    });
  },
  /**
   * 获取评价信息
   */
  getEvaluateInfoByOrder(serviceOrderId: number | string) {
    return request<ServiceEvaluateInfo>({
      path: '/pad/feedback/v1/get/by/order',
      query: { serviceOrderId },
    });
  },

  /**
   * 更新服务记录
   */
  updateServiceRecord(params: ServiceEvaluateSubmitParams) {
    return request<string>({
      method: 'POST',
      path: '/pad/feedback/v1/edit',
      data: params,
    });
  },

  /**
   * 获取门店的累计订单数值&&累计服务人数
   */
  getStoreOrderInfo() {
    return request<StoreOrderInfo>({
      path: '/pad/service/order/v1/stats/all',
    });
  },

  /**
   * 根据时间维度获取图表数据
   */
  getChartDataByMonth(params: GetChartByDateParams) {
    return request<GetChartDateByMonthResponse[]>({
      path: '/pad/service/order/v1/stats/list/month',
      query: params,
    });
  },

  getChartDataByWeek(params: GetChartByDateParams) {
    return request<GetChartDateByWeekResponse[]>({
      path: '/pad/service/order/v1/stats/list/week',
      query: params,
    });
  },
  getChartDataByDay(params: GetChartByDateParams) {
    return request<GetChartDateByDayResponse[]>({
      path: '/pad/service/order/v1/stats/list/day',
      query: params,
    });
  },

  /**
   * 获取会员记录信息
   */
  getMemberRecord(params: GetMemberRecordParams) {
    return request<GetCustomerServiceResponse[]>({
      path: '/pad/service/order/v1/customer/list',
      query: params,
    });
  },

  /**
   * 获取会员历史订单时间范围
   */
  getMemberTimeRange(customerId: number) {
    return request<GetCustomerTimeRange>({
      path: '/pad/service/order/v1/customer/timeRange',
      query: { customerId },
    });
  },
  /**
   * 获取消费数据 饼图 && 柱形图
   */
  getMemberConsumptionInfo(params: GetMemberConsumptionInfoParams) {
    return request<GetMemberConsumptionInfoResponse[]>({
      path: '/pad/service/order/v1/customerOrder/stats/itemTypes',
      query: params,
    });
  },
  /**
   * 获取会员订单信息
   */
  getMemberOrderByDate(params: GetMemberOrderInfoParams) {
    return request<MemberOrderItem[]>({
      path: '/pad/service/order/v1/customerOrder/list',
      query: params,
    });
  },
};

export default serviceRecordApi;
